<template>
    <apexchart :width="width" type="bar" :options="options" :series="options.series"></apexchart>
</template>

<script>

export default{
  name: 'BarChart',
  props: {
    title: String,
    width: String,
    legend_y: String,
    title: String,
    data: Array,
    xasis: Array,
  },
  data() {
    return {
      options:  {
        series: this.data,
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        title: {
          text: this.title,
          align: 'center'
        },
        colors: ['#AF104C', '#8a0e3ddc', '#5e0c2bc7'],
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.xasis,
        },
        yaxis: {
          title: {
            text: this.title_y
          }
        },
        fill: {
          opacity: 1
        },
        grid: {
          row: {
            colors: ['#AF104C', 'transparent'], 
            opacity: 0.04
          },
        }
      }
    } 
  }
}
</script>

<style scoped>
  .vds{
    color: #5e0c2bc7;
  }
</style>